import surfaceNodeMovedOnSurfaceMutation from 'graphql/surface/mutations/surface-node-moved-on-surface';
import { throttle } from 'lodash';
import { Position } from 'types';

const surfaceNodeMovedOnSurface = throttle(
  surfaceNodeMovedOnSurfaceMutation,
  150,
);

interface NodeMovedInput {
  id: string;
  surface: string;
  position: Position;
  index?: number;
}

export default function useSurfaceNodeMovedOnSurface() {
  return async function nodeMoved(input: NodeMovedInput) {
    return surfaceNodeMovedOnSurface({ input });
  };
}
